import angular from 'angular';
import uiRouter from 'angular-ui-router';
import changePasswordComponent from './changePassword.component';

let changePasswordModule = angular.module('changePassword', [
  uiRouter
])

.component('changePassword', changePasswordComponent)
.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('auth.changePassword', {
      url: '/changePassword?id',
      component: 'changePassword',
      name: 'auth.changePassword',
      params: {redirect: null}
    });
})
.name;

export default changePasswordModule;



// WEBPACK FOOTER //
// ./client/app/components/changePassword/changePassword.js